'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var NextStepAppIcon = function NextStepAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 400 400"
  }), React__default["default"].createElement("g", null, React__default["default"].createElement("polygon", {
    fill: "#FB661A",
    points: "178.8,395.4 374.2,200 211.3,37.2 178.8,4.6 113.6,69.7 243.9,200 113.6,330.3 \t"
  }), React__default["default"].createElement("polygon", {
    fill: "#FB661A",
    points: "97.3,314 211.3,200 116.3,105 97.3,86 59.3,124 135.3,200 59.3,276 \t"
  }), React__default["default"].createElement("polygon", {
    fill: "#FB661A",
    points: "23.6,240.2 43.7,260.3 104,200 53.7,149.7 43.7,139.7 23.6,159.8 63.8,200 \t"
  })));
};

var NextStepAppIcon$1 = iconStyles()(NextStepAppIcon);

module.exports = NextStepAppIcon$1;
